import React from "react";
import { Link } from "react-router-dom";

// import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import "./navbar.css";

// function getstyle(props,parent){
//   if(props.makebold =="HOME" && parent == ){
//     "fontWeight:'bold'"
//   }
//   else if (props.makebold == "ALL"){

//   }
// }

const Navbar = (props) => {

  return (
    <div className="secnav__navbar">
      <div className="secnav__navbar__home">
        {props.makebold === "HOME" ? 
          <Link to="/" style={{ textDecoration: "none", color: "#000",fontWeight:"bold"}}>
            HOME
          </Link>
         : 
          <Link to="/" style={{ textDecoration: "none", color: "#000" }}>
            HOME
          </Link>
        }
      </div>
      /
      <div className="secnav__navbar__allmeasures">
      {props.makebold === "ALL" ? 
          <Link to="/allmeasures" style={{ textDecoration: "none", color: "#000",fontWeight:"bold"}}>
            ALL SECURITY MEASURES
          </Link>
         : 
          <Link to="/allmeasures" style={{ textDecoration: "none", color: "#000" }}>
           ALL SECURITY MEASURES
          </Link>
        }
      </div>
    </div>
  );
};

export default Navbar;
